import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import Navigation from 'components/navigation';

const CheckListData = ({ data, result, menu, step, setStep }) => {
  const [check, setCheck] = useState([]);
  const [next, setNext] = useState(false);

  const selectedItem = id => {
    if (check.includes(id)) {
      setCheck(check.filter(item => item !== id));
    } else {
      setCheck([...check, id]);
    }
  };
  
  useEffect(() => {
    if (result && result[menu + 1] && result[menu + 1][2]) {
      setCheck(result[menu + 1][2]);
    }
  }, []);

  useEffect(() => {
    let mas = [];
    data &&
      data.checkListData_forEachModule[menu].forEach((item, index) => {
        if (item.isRightAnswer) {
          mas.push(index);
        }
      });
    if (
      mas.length === check.length &&
      mas.every(item => {
        return check.includes(item);
      })
    ) {
      setNext(true);
    } else {
      setNext(false);
    }
  }, [check]);

  return (
    <div className="checkList-wrapper">
      <h1 className="titile-step">Menu</h1>
      <h2 className="step-number">Step {step}</h2>
      {data &&
        data.checkListData_forEachModule[menu].map((item, index) => (
          <div
            key={index}
            className={classnames('module-wrapper', {
              check: check.includes(index),
            })}
            onClick={() => selectedItem(index)}
          >
            <div className="module-text">
              <div className="module-title">
                {index + 1 + '. ' + item.title}
              </div>
              <div className="module-info">{item.info}</div>
            </div>
            <div className="module-img">
              <img src={item.img} alt="plan" />
            </div>
          </div>
        ))}
      <Navigation
        step={step}
        setStep={setStep}
        next={next}
        answer={{ menu: menu + 1, answ: { 2: check.map(item => item + 1) } }}
      />
    </div>
  );
};

export default CheckListData;
